import { Column, createColumn } from '../../entities/column/Column'
import { api, Api } from '../../services/api'
import { transformColumn } from '../../transformers/column/ColumnTransformer'
import { formatDate } from '../../utils/format-date'
import { IColumnDataHandler } from './IColumnDataHandler'

export class ColumnApiDataHandler implements IColumnDataHandler {
  api: Api
  _transformer: typeof transformColumn

  constructor() {
    this.api = api
    this._transformer = transformColumn
  }

  async queryByDate(date: Date): Promise<Column[]> {
    const {data} = await this.api.client.get('sra_dashboard_columns_grouped', {
      params: {
        date: formatDate(date),
      },
    })
    const transformedColumns = data.columns.map(transformColumn)
    return transformedColumns.map(createColumn)
  }
}
